import { ServerFetch } from '../main-model'

export default class ReturnProductChangeModel extends ServerFetch {
    getReturnProductChangeBy = (data) => this.authFetch({
        url: 'return-product-change/getReturnProductChangeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}